import React from 'react'
import TailwindButtonDynamic from '../Layout/TailwindComponents/TailwindButtonDynamic';
import utils from '../../utils';
import LBSelect from '../DesignSystem/LBSelect/LBSelect';
import LBInput from '../DesignSystem/LBInput/LBInput';


function VPOPCampaignInputs({ disabled=false, year, index, removeCampaignRow, yearsToShow, productOptions, campaignTypeOptions, handleCampaignOptimization }) {

    const addBtnContent = {
        name: '',
        icon: utils.getIcon('xCircle', 'svg-12 m-i-start vertical-align'),
    }


    
    return (


            <div>
                <div className="grid grid-cols-[repeat(6,1fr),48px] w-full gap-2 mb-4">
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>{`Year of Campaign `}</label>
                        <LBSelect
                            placeholder={year.year ? year.year : null}
                            value={year.year ?? ''}
                            onChange={(e) => handleCampaignOptimization({type: 'year', value: e})}
                            options={yearsToShow}
                            maxHeight='auto'
                            minHeight='auto'
                            size='small'
                            disabled={disabled}
                            className="w-full"
                        />
                    </div>
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>{`Campaign Type`}</label>
                        <LBSelect 
                            placeholder={year.campaign_type ? year.campaign_type : null}
                            value={year.campaign_type ?? ''}
                            options={campaignTypeOptions}
                            maxHeight='auto'
                            minHeight='auto'
                            size='small'
                            onChange={(e) => handleCampaignOptimization({type: 'campaign_type', value: e})}
                            disabled={disabled}
                            className="w-full"
                            />
                    </div>
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>{`Product`}</label>
                        <LBSelect
                            placeholder={year.product_characteristic && year.product_characteristic.product_characteristic_name ? 
                                year.product_characteristic.product_characteristic_name.slice(0, 20) : null}
                            value={year.product_characteristic && year.product_characteristic.product_characteristic_name ? 
                                year.product_characteristic.product_characteristic_name.slice(0, 20) : ''}
                            options={productOptions}
                            maxHeight='auto'
                            minHeight='auto'
                            size='small'
                            onChange={(e) => {handleCampaignOptimization({type: 'product_characteristic', value: e});}}
                            disabled={disabled}
                            className="w-full"
                        />
                    </div>
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>Min age</label>
                        <LBInput
                            label=''
                            value={year?.min_age ?? null}
                            type="number"
                            onChange={(e) => handleCampaignOptimization({type: 'min_age', value: Number(e.target.value)})}
                            disabled={disabled}
                            className="w-full"
                        />
                    </div>
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>Max age</label>
                        <LBInput
                            label=''
                            value={year?.max_age ?? null}
                            type="number"
                            onChange={(e) => handleCampaignOptimization({type: 'max_age', value: Number(e.target.value)})}
                            disabled={disabled}
                            className="w-full"
                        />
                    </div>
                    <div className="min-w-0">
                        <label className='label-medium block mb-03'>TRS/Uptake Overrides</label>
                        <LBInput
                            label=''
                            type='number'
                            onChange={(e)=> handleCampaignOptimization({type: 'uptake_or_trs', value: Number(e.target.value)})}
                            value={year?.uptake_or_trs ?? null}
                            disabled={disabled}
                            className="w-full"
                        />
                    </div>
                    {
                        !disabled &&
                            <div>
                                <TailwindButtonDynamic 
                                    disabled={false}
                                    actionHandler={() => removeCampaignRow(index)}
                                    content={addBtnContent}
                                    variant='tertiarySmallSurfaceBrandSecondary'
                                    classSpecific={'!text-red-500 !border-transparent !bg-transparent hover:!bg-[var(--surface-error-light)] mt-06'}
                                />
                                    
                            </div>
                    }
                </div>
            </div>
  )
}

export default VPOPCampaignInputs
